import { jsxs as C, jsx as t } from "react/jsx-runtime";
import { createElement as E } from "react";
import { StyledFormControl as L, StyledSelect as k } from "./styles66.mjs";
import { MenuItem as v, FormHelperText as w } from "@mui/material";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import { useFormFieldSize as B } from "./useFormFieldSize.mjs";
import { Value as H } from "./index178.mjs";
import { InputLabelBase as I } from "./index46.mjs";
const U = ({
  disabled: l,
  fullWidth: n,
  label: m,
  labelType: i = "outside",
  labelId: a,
  variant: d,
  size: h = "small",
  helperText: u,
  value: r,
  onChange: y,
  name: z,
  defaultValue: F,
  error: V,
  withChips: x = !1,
  options: c,
  children: p,
  displayEmpty: $ = !0,
  placeholder: g,
  multiple: j = !1,
  isOptional: f,
  required: o,
  ...A
}) => {
  const s = B(h), S = i === "inside" && m ? /* @__PURE__ */ t(I, { required: o, isOptional: f, children: m }) : void 0;
  return /* @__PURE__ */ C(
    L,
    {
      disabled: l,
      fullWidth: n,
      label: S || m,
      labelType: i,
      id: a,
      variant: d,
      size: s,
      error: V,
      isOptional: f,
      required: o,
      children: [
        /* @__PURE__ */ t(
          k,
          {
            $size: s,
            $withChips: x,
            $hasValue: Array.isArray(r) ? r.length > 0 : !!r,
            labelId: a,
            label: S,
            fullWidth: n,
            value: r === null ? "" : r,
            onChange: y,
            disabled: l,
            size: s,
            name: z,
            variant: d,
            displayEmpty: i === "outside" && $,
            multiple: j,
            required: o,
            renderValue: (e) => /* @__PURE__ */ t(
              H,
              {
                options: c,
                selected: e,
                placeholder: g,
                children: p
              }
            ),
            defaultValue: F ?? "",
            ...A,
            children: p || c?.map((e) => /* @__PURE__ */ E(
              v,
              {
                ...e,
                key: e.value?.toString(),
                value: e.value ?? ""
              },
              e.label
            ))
          }
        ),
        !!u && /* @__PURE__ */ t(w, { component: "div", children: u })
      ]
    }
  );
};
export {
  U as Select
};
//# sourceMappingURL=index99.mjs.map
